import { Box, Button, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { iresoftColors } from "../../../theme/ireColors";

const Footer = () => {
  const theme = useTheme();

  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 0.5, sm: 0.6 },
        px: 4,
        borderTop: "1px solid",
        borderColor: "divider",
        opacity: 0.9,
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: theme.palette.background.default,
        fontSize: theme.typography.body2,
        zIndex: 1000,
        WebkitUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          justifyContent: { xs: "center", sm: "flex-end" },
          textAlign: "center",
          width: "100%",
          position: "relative",
          mt: -1,
        }}
      >
        <Button
          variant="text"
          size="small"
          href="mailto:chcizazit@iresoft.cz"
          sx={{
            borderColor: iresoftColors.iresoftRed,
            color: iresoftColors.iresoftRed,
            fontWeight: "bold",
            textTransform: "none",
            order: { xs: 1, sm: 2 },
            alignSelf: { xs: "center", sm: "auto" },
            mt: { xs: 0.3, sm: 0 },
            px: 2.5,
          }}
        >
          chcizazit@iresoft.cz
        </Button>

        <Typography
          variant="inherit"
          sx={{
            color: iresoftColors.black80,
            fontSize: 12,
            cursor: "pointer",
            order: { xs: 2, sm: 1 },
            mx: { xs: "auto", sm: 0 },
            position: { xs: "static", sm: "absolute" },
            left: { sm: "50%" },
            transform: { sm: "translateX(-50%)" },
          }}
          onClick={() => window.open("https://www.iresoft.cz", "_blank")}
        >
          {t("footer.copyright")}
        </Typography>
      </Box>
    </Box>
  );
};

export default React.memo(Footer);
